import script from "./MessageList.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageList.vue?vue&type=script&setup=true&lang=js"

import "./MessageList.vue?vue&type=style&index=0&id=3f8de3a1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f8de3a1"]])

export default __exports__